import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, createClass as _createClass, defineProperty as _defineProperty, taggedTemplateLiteral as _taggedTemplateLiteral, extends as _extends, objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import propTypes from '../../../node_modules/prop-types/index.js';
import React from 'react';
import classnames from '../../../node_modules/classnames/index.js';
import { styled, useThemeProps } from '@mui/material';
import Field from '../Field.js';
import connectForm$1 from '../../../cinnamon-core/es/components/forms/connectForm.js';
import MonthPicker from '../../dates/MonthPicker.js';
import { createComponentSlot } from '../../../modules/styling/theme.js';
import { prettifyField, omitProps, fieldErrors } from '../../../cinnamon-core/es/components/forms/utils.js';
import { requiredField } from '../../../cinnamon-core/es/components/forms/validators/requiredField.js';

var _templateObject;
var componentRoot = createComponentSlot({
  name: "CinFormMonth",
  slot: "Root"
});

var MonthBase = /*#__PURE__*/function (_React$Component) {
  _inherits(MonthBase, _React$Component);

  var _super = _createSuper(MonthBase);

  function MonthBase() {
    _classCallCheck(this, MonthBase);

    return _super.apply(this, arguments);
  }

  _createClass(MonthBase, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          value = _this$props.value,
          onChange = _this$props.onChange,
          errors = _this$props.errors,
          showErrors = _this$props.showErrors,
          allErrors = _this$props.allErrors,
          animateErrors = _this$props.animateErrors,
          disabled = _this$props.disabled,
          readOnly = _this$props.readOnly,
          renderReadOnly = _this$props.renderReadOnly,
          label = _this$props.label,
          labelProps = _this$props.labelProps,
          actions = _this$props.actions,
          width = _this$props.width,
          fluid = _this$props.fluid,
          required = _this$props.required,
          passThruProps = _this$props.passThruProps,
          forwardedRef = _this$props.forwardedRef,
          className = _this$props.className;
      var otherProps = omitProps(passThruProps, Object.keys(MonthBase.propTypes));

      var fieldLabelProps = _objectSpread2({
        variant: readOnly && renderReadOnly ? "field" : "input"
      }, labelProps);

      return /*#__PURE__*/React.createElement(Field, {
        required: required,
        disabled: disabled,
        renderReadOnly: readOnly && renderReadOnly ? function () {
          return renderReadOnly(_this.props);
        } : false,
        width: width,
        fluid: fluid,
        label: fieldLabelProps.variant === "input" ? undefined : label,
        labelProps: fieldLabelProps,
        actions: actions,
        errors: fieldErrors(errors, showErrors, allErrors),
        animateErrors: animateErrors,
        className: classnames(componentRoot.className, className),
        ref: forwardedRef
      }, /*#__PURE__*/React.createElement(MonthPicker, _extends({}, otherProps, {
        value: value,
        onChange: onChange,
        label: fieldLabelProps.variant === "input" ? label : undefined,
        readOnly: readOnly
      })));
    }
  }]);

  return MonthBase;
}(React.Component);

_defineProperty(MonthBase, "propTypes", {
  notifiedFields: propTypes.arrayOf(propTypes.string),
  customValidator: propTypes.func,
  customErrors: propTypes.arrayOf(propTypes.string),
  readOnly: propTypes.bool,
  disabled: propTypes.bool,
  animateErrors: propTypes.oneOfType([propTypes.number, propTypes.bool]),
  allErrors: propTypes.bool,
  showErrors: propTypes.bool,
  field: propTypes.string.isRequired,
  requiredError: propTypes.string,
  required: propTypes.bool,
  variant: propTypes.any,
  sx: propTypes.any,
  className: propTypes.string,
  renderReadOnly: propTypes.func,
  fluid: propTypes.bool,
  width: propTypes.oneOfType([propTypes.number, propTypes.string]),
  actions: propTypes.node,
  labelProps: propTypes.any,
  label: propTypes.node
});

_defineProperty(MonthBase, "defaultProps", {
  value: "",
  onChange: function onChange() {}
});

var ConnectedMonth = connectForm$1({
  displayName: function displayName(props) {
    return props.label && typeof props.label === "string" ? props.label : prettifyField(props.field);
  },
  validators: [requiredField(false)]
})(MonthBase);
var MonthRoot = styled(ConnectedMonth, componentRoot.styledOptions)(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
MonthRoot.defaultProps = {
  variant: "outlined"
};
/**
 * Field for choosing a month
 */

var MonthField = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var rootProps = useThemeProps({
    props: props,
    name: componentRoot.name
  });
  return /*#__PURE__*/React.createElement(MonthRoot, _extends({}, rootProps, {
    ref: ref
  }));
});
var MonthField$1 = MonthField;

export { MonthField$1 as default };
